"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _breakpoints = _interopRequireDefault(require("./breakpoints"));
var _colors = _interopRequireDefault(require("./colors"));
var _functions = _interopRequireDefault(require("./functions"));
var _typography = _interopRequireDefault(require("./typography"));
var _variables = _interopRequireDefault(require("./variables"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var INPUT_PADDING = {
  paddingTop: _functions.default.toRem(_variables.default.inputPaddingTop),
  paddingRight: _functions.default.toRem(_variables.default.inputPaddingRight),
  paddingBottom: _functions.default.toRem(_variables.default.inputPaddingBottom),
  paddingLeft: _functions.default.toRem(_variables.default.inputPaddingLeft)
};
var INPUT_READONLY_VALUE = {
  backgroundColor: _colors.default.blueGrey,
  boxShadow: 'none',
  color: _colors.default.battleshipGrey,
  // readonly styles should override disabled styles
  '-webkit-text-fill-color': _colors.default.battleshipGrey,
  '-webkit-opacity': 1,
  cursor: 'text',
  pointerEvents: 'auto'
};
var INPUT_DISABLE_VALUE = _objectSpread(_objectSpread({}, INPUT_READONLY_VALUE), {}, {
  color: _colors.default.battleshipGrey,
  // Safari overrides font color for disabled inputs
  // https://stackoverflow.com/questions/262158/disabled-input-text-color
  '-webkit-text-fill-color': _colors.default.battleshipGrey,
  '-webkit-opacity': 1,
  cursor: 'default',
  // not-allowed
  pointerEvents: 'none'
});
var INPUT_FOCUS_VALUE = {
  borderColor: _colors.default.blueGrey,
  backgroundColor: _colors.default.blueGrey,
  boxShadow: 'none'
};
var INPUT_PLACEHOLDER_VALUE = _objectSpread(_objectSpread({}, _typography.default.baseText), {}, {
  color: _colors.default.battleshipGrey,
  cursor: 'text'
});
var VERTICAL_ALIGN_VALUE = {
  // Requires relatively positioned parent element
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)'
};
var COLOR_KEYS = Object.keys(_colors.default);
var SELECT_DISPLAY_NAME = 'MultiSelectInput';
var mixins = {
  /* Avatar
  /* ----------------------------------- */
  circle: {
    borderRadius: '50%',
    height: '2.125em',
    width: '2.125em'
  },
  /* Collection View
  /* ----------------------------------- */
  galleryGrid: {
    '@media (min-width: 490px)': {
      width: 'calc(100% / 2)'
    },
    '@media (min-width: 794px)': {
      width: 'calc(100% / 3)'
    },
    '@media (min-width: 1020px)': {
      width: 'calc(100% / 4)'
    },
    '@media (min-width: 1340px)': {
      width: 'calc(100% / 5)'
    },
    '@media (min-width: 1828px)': {
      width: 'calc(100% / 6)'
    },
    '@media (min-width: 2240px)': {
      width: 'calc(100% / 7)'
    }
  },
  /* Link
  /* ----------------------------------- */
  link: {
    color: _colors.default.textLink,
    backgroundColor: 'transparent',
    textDecoration: 'none',
    '&:active': {
      opacity: 0.8,
      textDecoration: 'none'
    }
  },
  unsetLink: {
    color: _colors.default.black,
    '&:active': {
      opacity: 1
    }
  },
  /* Modal View
  /* ----------------------------------- */
  bodyOpen: {
    overflow: 'hidden'
  },
  /* Info Bar
  /* ----------------------------------- */
  infoBarLabel: _objectSpread(_objectSpread({}, _typography.default.extraSmallText), {}, {
    fontSize: '0.625rem',
    fontWeight: 500,
    letterSpacing: '.0625rem',
    marginBottom: '.25rem',
    display: 'block',
    textTransform: 'uppercase',
    color: _colors.default.pebbleGrey
  }),
  /* Inputs
  /* ----------------------------------- */
  inputStyle: _objectSpread(_objectSpread(_objectSpread({}, _typography.default.baseText), INPUT_PADDING), {}, {
    appearance: 'none',
    // Reset the default appearance
    borderRadius: _variables.default.borderRadius,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: _colors.default.blueGrey,
    backgroundColor: _colors.default.blueGrey,
    boxShadow: 'none',
    boxSizing: 'border-box',
    width: '100%',
    position: 'relative',
    cursor: 'text',
    '&:focus, &:hover': INPUT_FOCUS_VALUE,
    '&[readonly]': {
      '&, &:focus, &:hover': INPUT_READONLY_VALUE
    },
    '&:disabled': {
      '&, &:focus, &:hover': INPUT_DISABLE_VALUE
    },
    '&::placeholder': INPUT_PLACEHOLDER_VALUE,
    '&::-webkit-input-placeholder': INPUT_PLACEHOLDER_VALUE,
    '&:-ms-input-placeholder': INPUT_PLACEHOLDER_VALUE,
    '&::-ms-input-placeholder': INPUT_PLACEHOLDER_VALUE,
    '&::-moz-placeholder': INPUT_PLACEHOLDER_VALUE,
    '&:-moz-placeholder': INPUT_PLACEHOLDER_VALUE
  }),
  inputContainer: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    marginLeft: '-.125rem',
    padding: 0,
    minHeight: '2.25rem',
    '-webkit-overflow-scrolling': 'touch',
    position: 'relative',
    boxSizing: 'border-box'
  },
  inputDisabled: INPUT_DISABLE_VALUE,
  inputEmpty: _objectSpread(_objectSpread({}, _typography.default.baseText), {}, {
    padding: 0,
    color: _colors.default.battleshipGrey,
    textAlign: 'center'
  }),
  inputEmbedded: _objectSpread(_objectSpread({}, _typography.default.smallText), {}, {
    height: '2rem',
    paddingTop: '.25rem',
    paddingBottom: '.25rem',
    lineHeight: '1.43rem',
    border: "1px solid ".concat(_colors.default.lightGrey),
    borderRadius: _variables.default.borderRadiusSmall,
    backgroundColor: _colors.default.ghostWhite,
    margin: 0,
    '&:hover, &:focus, &:focus-within': {
      backgroundColor: _colors.default.ghostWhite,
      border: "1px solid ".concat(_colors.default.lightGrey)
    }
  }),
  inputError: {
    '&, &:focus, &:hover': {
      borderColor: "".concat(_colors.default.dullRed, " !important"),
      boxShadow: "inset 0 0 0 1px ".concat(_colors.default.dullRed, " !important")
    }
  },
  inputErrorMessage: _objectSpread(_objectSpread({}, _typography.default.extraSmallText), {}, {
    display: 'block',
    marginBottom: '.375rem',
    color: _colors.default.dullRed,
    '&:first-letter': {
      textTransform: 'uppercase'
    }
  }),
  inputInlineErrorMessage: _objectSpread(_objectSpread(_objectSpread({}, _typography.default.baseText), VERTICAL_ALIGN_VALUE), {}, {
    position: 'absolute',
    right: '.938rem',
    display: 'flex',
    alignItems: 'center',
    color: _colors.default.dullRed
  }),
  inputInlineErrorIcon: {
    flex: 'none',
    marginLeft: '.5rem'
  },
  inputFocus: INPUT_FOCUS_VALUE,
  inputMenu: {
    borderColor: _colors.default.blueGrey,
    backgroundColor: _colors.default.white,
    boxShadow: "0 .25rem .5rem ".concat(_colors.default.pastelGreyAlpha)
  },
  inputMultiLabel: _objectSpread(_objectSpread({}, _typography.default.smallText), {}, {
    color: _colors.default.black,
    borderRadius: _variables.default.borderRadiusSmall,
    padding: '.188rem .5rem',
    boxSizing: 'border-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minHeight: '1.625rem'
  }),
  inputMultiLabelDisabled: {
    color: _colors.default.battleshipGrey
  },
  inputMultiPadding: {
    paddingTop: _functions.default.toRem(_variables.default.inputMultiPaddingTop),
    paddingBottom: _functions.default.toRem(_variables.default.inputMultiPaddingBottom)
  },
  inputMultiRemove: {
    color: _colors.default.black,
    alignItems: 'center',
    borderRadius: _variables.default.borderRadiusSmall,
    display: 'flex',
    paddingLeft: '.5rem',
    paddingRight: '.5rem',
    boxSizing: 'border-box',
    cursor: 'pointer',
    '&:focus, &:hover': {
      backgroundColor: 'transparent',
      color: _colors.default.black
    },
    '& svg': {
      display: 'inline-block',
      fill: _colors.default.pastelGrey,
      lineHeight: 1,
      stroke: _colors.default.pastelGrey,
      strokeWidth: 0
    }
  },
  inputMultiRemoveDisabled: {
    backgroundColor: 'transparent',
    color: _colors.default.battleshipGrey
  },
  inputMultiValue: {
    backgroundColor: _colors.default.ghostWhite,
    border: "1px solid ".concat(_colors.default.lightGrey),
    borderRadius: _variables.default.borderRadiusSmall,
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '.188rem',
    marginRight: '.375rem',
    marginBottom: '.188rem',
    marginLeft: 0,
    boxSizing: 'border-box',
    maxWidth: '100%'
  },
  inputMargin: {
    marginRight: "-".concat(_functions.default.toRem(_variables.default.inputMarginRight)),
    marginLeft: "-".concat(_functions.default.toRem(_variables.default.inputMarginLeft))
  },
  inputPadding: INPUT_PADDING,
  inputPlaceholder: INPUT_PLACEHOLDER_VALUE,
  inputReadOnly: INPUT_READONLY_VALUE,
  inputRequired: _objectSpread(_objectSpread(_objectSpread({}, VERTICAL_ALIGN_VALUE), _typography.default.extraSmallText), {}, {
    right: _functions.default.toRem(_variables.default.inputPaddingLeft),
    color: _colors.default.battleshipGrey,
    cursor: 'default',
    pointerEvents: 'none'
  }),
  inputSuccess: {
    // Disabling valid input highlighting per
    // https://github.com/catalyticlabs/product/issues/5074
    // '&, &:focus, &:hover': {
    //   borderColor: `${colors.navyGreen} !important`
    // }
  },
  // These styles allow SwitchInput to be positioned in the top-right corner of the Input component
  // e.g. <Input className="inputSwitchContainer"><SwitchInput className="inputSwitch" /></Input>
  inputSwitchContainer: {
    position: 'relative',
    paddingRight: _functions.default.toRem(_variables.default.inputSwitchWidth + _variables.default.base)
  },
  inputSwitch: {
    position: 'absolute',
    top: 0,
    right: 0,
    marginTop: '0 !important' // Override Input component margin-top styles
  },
  inputResponsiveDropDown: (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "& .".concat(SELECT_DISPLAY_NAME, "__control"), {
    flexWrap: 'nowrap',
    paddingRight: '.75rem',
    paddingLeft: '.75rem',
    borderColor: _colors.default.blueGrey,
    backgroundColor: _colors.default.blueGrey,
    '&:hover, &:focus, &:focus-within': {
      borderColor: _colors.default.blueGrey,
      backgroundColor: _colors.default.blueGrey
    }
  }), "& .".concat(SELECT_DISPLAY_NAME, "__single-value"), (0, _defineProperty2.default)({}, _breakpoints.default.gte.tablet.portrait, {
    maxWidth: '9.5rem',
    // 152px based on "All Team Members" option
    minWidth: '2.375rem',
    // 38px to supplement "Any" option
    position: 'relative',
    top: 'auto',
    transform: 'none'
  })), "& .".concat(SELECT_DISPLAY_NAME, "__value-container"), {
    flexBasis: 'auto',
    flexWrap: 'nowrap',
    height: 0 // This hack fixes vertical-alignment issues in IE11
  }), "& .".concat(SELECT_DISPLAY_NAME, "__single-value-container"), {
    display: 'flex',
    minWidth: 0
  }), "& .".concat(SELECT_DISPLAY_NAME, "__menu"), (0, _defineProperty2.default)({}, _breakpoints.default.gte.tablet.portrait, {
    maxWidth: '21.875rem',
    // 350px based on the size of the `NavbarUser.js` menu
    minWidth: '100%',
    width: 'auto'
  })), '& input', {
    borderColor: _colors.default.blueGrey,
    backgroundColor: _colors.default.blueGrey,
    '&:hover, &:focus, &:focus-within': {
      borderColor: _colors.default.blueGrey,
      backgroundColor: _colors.default.blueGrey
    }
  }),
  /* Forms
  /* ----------------------------------- */
  formButton: {
    padding: '.625rem 1rem',
    width: '100%',
    borderRadius: _variables.default.borderRadius
  },
  formMarginBottom: (0, _defineProperty2.default)({
    marginBottom: '6.25rem'
  }, _breakpoints.default.tablet, {
    marginBottom: '7.5rem'
  }),
  /* View All
  /* ----------------------------------- */
  viewAll: _objectSpread(_objectSpread({}, _typography.default.header6), {}, {
    backgroundColor: _colors.default.blueGrey,
    borderTop: "1px solid ".concat(_colors.default.pastelGrey),
    color: _colors.default.pebbleGrey,
    letterSpacing: '-0.012rem',
    padding: '0.75rem'
  }),
  /* Disabled
  /* ----------------------------------- */
  disabled: {
    opacity: 0.5,
    outline: 'none',
    cursor: 'default',
    // not-allowed
    pointerEvents: 'none',
    filter: 'grayscale(100%)',
    backgroundColor: 'inherit',
    '&:active, &:focus, &:hover': {
      backgroundColor: 'inherit'
    }
  },
  /* Truncate
  /* ----------------------------------- */
  truncate: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  /* Break word
   * https://css-tricks.com/snippets/css/prevent-long-urls-from-breaking-out-of-container/
  /* ----------------------------------- */
  breakWord: {
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    hyphens: 'none'
  },
  /* Vertical Align
  /* ----------------------------------- */
  verticalAlign: VERTICAL_ALIGN_VALUE,
  /* Visually Hidden
   *
   * Only display content to screen readers
   * See: https://a11yproject.com/posts/how-to-hide-content/
   * See: https://hugogiraudel.com/2016/10/13/css-hide-and-seek/
  /* ----------------------------------- */
  visuallyHidden: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0
  },
  /* Color Scheme
  /* ----------------------------------- */
  colorScheme: _objectSpread({}, COLOR_KEYS.reduce(function (accumulator, color) {
    var hex = _colors.default[color];
    return _objectSpread(_objectSpread({}, accumulator), {}, (0, _defineProperty2.default)({}, "&[data-color=\"".concat(color, "\"]"), {
      borderColor: hex,
      backgroundColor: hex,
      color: _colors.default.white
    }));
  }, {})),
  /* Invert Scheme
  /* ----------------------------------- */
  invertScheme: _objectSpread({
    backgroundColor: _colors.default.white,
    border: "1px solid ".concat(_colors.default.pastelGrey)
  }, COLOR_KEYS.reduce(function (accumulator, color) {
    var hex = _colors.default[color];
    return _objectSpread(_objectSpread({}, accumulator), {}, (0, _defineProperty2.default)({}, "&[data-color=\"".concat(color, "\"]"), {
      color: hex
    }));
  }, {}))
};
var _default = exports.default = mixins;
//# sourceMappingURL=mixins.js.map